import '../scss/app.scss';

// import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/dropdown';

// import 'bootstrap';

import gsap from 'gsap';
import { Linear, Back, Power1 }from 'gsap/all';

import './owl.carousel.min';
const particlesContainer = document.getElementById('particles_container')

var density = 50,       // amount of particles
    speed = 2,
    winHeight = particlesContainer ? particlesContainer.clientHeight : null,
    winWidth = particlesContainer ? particlesContainer.clientWidth : null,
    start = {
        yMin: winHeight - 50,
        yMax: winHeight,
        xMin: (winWidth / 2) + 10,
        xMax: (winWidth / 2) + 40,
        scaleMin: 0.1,
        scaleMax: 0.25,
        scaleXMin: 0.1,
        scaleXMax: 1,
        scaleYMin: 1,
        scaleYMax: 2,
        opacityMin: 0.1,
        opacityMax: 0.4
    },
    mid = {
        yMin: winHeight * 0.4,
        yMax: winHeight * 0.9,
        xMin: winWidth * 0.1,
        xMax: winWidth * 0.9,
        scaleMin: 0.2,
        scaleMax: 0.8,
        opacityMin: 0.5,
        opacityMax: 1
    },
    end = {
        yMin: -180,
        yMax: -180,
        xMin: -100,
        xMax: winWidth + 180,
        scaleMin: 0.1,
        scaleMax: 1,
        opacityMin: 0.4,
        opacityMax: 0.7
    };

function range(map, prop) {
    var min = map[prop + 'Min'],
        max = map[prop + 'Max'];
    return min + (max - min) * Math.random();
}

function sign() {
    return Math.random() < 0.5 ? -1 : 1;
}

function randomEase(easeThis, easeThat) {
    if (Math.random() < 0.5) {
        return easeThat;
    }
    return easeThis;
}

function spawn(particle) {
    var wholeDuration = (10 / speed) * (0.7 + Math.random() * 0.4),
        delay = wholeDuration * Math.random(),
        partialDuration = (wholeDuration + 1) * (0.2 + Math.random() * 0.3);

    gsap.set(particle, {
        y: range(start, 'y'),
        x: range(start, 'x'),
        scaleX: range(start, 'scaleX'),
        scaleY: range(start, 'scaleY'),
        scale: range(start, 'scale'),
        opacity: range(start, 'opacity'),
        visibility: 'hidden'
    })

    // Moving upward
    gsap.to(particle, {
        duration: partialDuration,
        delay: delay,
        y: range(mid, 'y'),
        ease: randomEase(Linear.easeOut, Back.easeInOut)
    })


    // TweenLite.to(particle, wholeDuration - partialDuration, {
    gsap.to(particle, {
        duration: wholeDuration - partialDuration,
        delay: partialDuration + delay,
        y: range(end, 'y'),
        ease: Back.easeIn
    });

    //Moving on axis X
    gsap.to(particle, {
        duration: partialDuration,
        delay: delay,
        x: range(mid, 'x'),
        ease: Power1.easeOut
    });
    // TweenLite.to(particle, wholeDuration - partialDuration, {
    gsap.to(particle, {
        duration: wholeDuration - partialDuration,
        delay: partialDuration + delay,
        x: range(end, 'x'),
        ease: Power1.easeIn
    });

    //opacity and scale
    partialDuration = wholeDuration * (0.5 + Math.random() * 0.3);

    gsap.to(particle, {
        duration: partialDuration,
        delay: delay,
        scale: range(mid, 'scale'),
        autoAlpha: range(mid, 'opacity'),
        ease: Linear.easeNone
    });

    gsap.to(particle, {
        duration: wholeDuration - partialDuration,
        delay: partialDuration + delay,
        scale: range(end, 'scale'),
        autoAlpha: range(end, 'opacity'),
        ease: Linear.easeNone,
        onComplete: spawn,
        onCompleteParams: [particle]
    });
}

function createParticle(container) {
    var i, particleSpark;
    for (i = 0; i < density; i += 1) {
        particleSpark = document.createElement('div');
        particleSpark.classList.add('spark');
        container.appendChild(particleSpark);
        spawn(particleSpark);
    }
}

let currentSupportersBgIndex = 0,
    maxSupportersBgIndex = 3,
    supportersBgClassPrefix = 'bg-item-',
    supportersContainer = $('.supporters-background'),
    supportersSwitchTime = 3000;  // in miliseconds

function rotateSupporters() {

    ++currentSupportersBgIndex

    if(currentSupportersBgIndex >= maxSupportersBgIndex) {
        currentSupportersBgIndex = 0
    }

    supportersContainer.removeClass('active')
    $('.' + supportersBgClassPrefix + currentSupportersBgIndex).addClass('active')

    setTimeout(rotateSupporters, supportersSwitchTime)
}

function showGallery() {
    $('body').addClass('h-100 overflow-hidden')

    $('.gallery .gallery-carousel').owlCarousel({
        nav: false,
        items: 1
    })

    $('#gallery').show()
}

function hideGallery() {
    $('body').removeClass('h-100 overflow-hidden')
    $('#gallery').hide()
    $('#gallery .gallery-body').html('')
}


$(function() {

    // init carousel
    $('.owl-carousel').owlCarousel({
        nav: true,
        slideBy: 4,
        // navText: [],
        responsive: {
            0: {
                items: 1,
                slideBy: 1,
            },
            768: {
                items: 2,
                slideBy: 2,
            },
            992: {
                items: 4,
                nav: 1,
            }
        }
    })

    if(particlesContainer) {
        createParticle(particlesContainer)
    }

    rotateSupporters()

    // hover for navbar {
    $('.navbar .menu-item-has-children').hover(function() {
        $(this).children('.dropdown-menu').addClass('show');
    }, function() {
        $(this).children('.dropdown-menu').removeClass('show');
    })

    // gallery
    $('.jq-close-gallery').on('click', () => {
        hideGallery()
    })

    $('.jq-show-gallery').on('click', (event) => {

        const elTarget = $(event.currentTarget)
        let slideId = elTarget.data('slide-id')
        let galleryId = elTarget.data('gallery-id')

        if(!slideId) {
            slideId = 0
        }

        let galleryContent = $('.gallery-content[data-gallery-content-id="' + galleryId + '"]').html()

        $('.gallery-body').html(galleryContent)

        showGallery();
        $('#gallery .gallery-carousel').trigger('to.owl.carousel', [slideId, 300])   // [position, speed]
    })

    $(document).on('click', '#gallery .gallery-prev', () => {
        $('#gallery .gallery-carousel').trigger('prev.owl.carousel', [ 300 ])
    })

    $(document).on('click', '#gallery .gallery-next', () => {
        $('#gallery .gallery-carousel').trigger('next.owl.carousel', [ 300 ])
    })

    $(document).on('changed.owl.carousel', '#gallery .gallery-carousel', (event) => {
        let itemIndex = event.item.index
        let itemSlide = $(event.target).find('.gallery-carousel-item')[itemIndex]

        const name = $(itemSlide).data('name')
        const description = $(itemSlide).data('description')

        $('#gallery .gallery-name').text(name)
        $('#gallery .gallery-description').html(description)
    })
});
